export default __webpack_public_path__ + "static/media/heart.d4b78280.svg";